/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ClaimStatusTemplate } from './ClaimStatusTemplate';
import {
    ClaimStatusTemplateFromJSON,
    ClaimStatusTemplateFromJSONTyped,
    ClaimStatusTemplateToJSON,
    ClaimStatusTemplateToJSONTyped,
} from './ClaimStatusTemplate';

/**
 * List of claim status templates
 * @export
 * @interface ClaimStatusTemplateListResponse
 */
export interface ClaimStatusTemplateListResponse {
    /**
     * 
     * @type {Array<ClaimStatusTemplate>}
     * @memberof ClaimStatusTemplateListResponse
     */
    templates: Array<ClaimStatusTemplate>;
}

/**
 * Check if a given object implements the ClaimStatusTemplateListResponse interface.
 */
export function instanceOfClaimStatusTemplateListResponse(value: object): value is ClaimStatusTemplateListResponse {
    if (!('templates' in value) || value['templates'] === undefined) return false;
    return true;
}

export function ClaimStatusTemplateListResponseFromJSON(json: any): ClaimStatusTemplateListResponse {
    return ClaimStatusTemplateListResponseFromJSONTyped(json, false);
}

export function ClaimStatusTemplateListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimStatusTemplateListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'templates': ((json['templates'] as Array<any>).map(ClaimStatusTemplateFromJSON)),
    };
}

export function ClaimStatusTemplateListResponseToJSON(json: any): ClaimStatusTemplateListResponse {
    return ClaimStatusTemplateListResponseToJSONTyped(json, false);
}

export function ClaimStatusTemplateListResponseToJSONTyped(value?: ClaimStatusTemplateListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'templates': ((value['templates'] as Array<any>).map(ClaimStatusTemplateToJSON)),
    };
}

